import React, { useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TableSortLabel, Typography } from '@material-ui/core';
import Checkbox from '../checkbox';
import { useTranslate } from 'react-admin';

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor:theme.palette.primary.main,
        borderBottom: 'solid 5px ' + theme.palette.background.default,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);



const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
    },
    container: {
        maxHeight: 600,
    },
    tableCell: {
        maxWidth: 200,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        width: 50,
        borderBottom: 'solid 5px ' + theme.palette.background.default
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
        color: 'white'
    },
    tableSortLabel: {
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        lineHeight: '16.3px',
        letterSpacing: '0.13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        color: theme.palette.common.white,
        padding: '17px',
        '&:hover': {
            color: 'white'
        },
        '&:focus': {
            color: 'white'
        },
    },
    normalText: {
        fontSize: 13,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',

    },
    normalTextOffline: {
        fontSize: 13,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        color: '#e1503a',
        whiteSpace: 'nowrap',

    },
    normalTextOnline: {
        fontSize: 13,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        color: '#bbd593',
        whiteSpace: 'nowrap',
    },
    textTable: {
        fontFamily: 'UniviaPro-Book',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        color: '#4f5064',
        textAlign: 'center'
    },
}));

const headCells = [
    { id: 'name', numeric: false, disablePadding: true, label: 'Device' },
    { id: 'ipAddress', numeric: false, disablePadding: false, label: 'IP' },
    { id: 'model', numeric: false, disablePadding: false, label: 'Model' },
    { id: 'macAddress', numeric: false, disablePadding: false, label: 'MAC-Address' },
    { id: 'serialNumber', numeric: false, disablePadding: false, label: 'Serial number' },
    { id: 'firmware', numeric: false, disablePadding: false, label: 'Firmware' },
    // { id: 'status', numeric: false, disablePadding: false, label: 'Status' },
    { id: '', numeric: false, disablePadding: false, label: 'Assign/Unassign' },
];

function EnhancedTableHead(props) {
    const { classes, order, orderBy, onRequestSort, style } = props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                {headCells.map((headCell) => (
                    (
                        <StyledTableCell
                            key={'cell-' + headCell.id}
                            className={classes.tableSortLabel}
                        >
                            {headCell.label}
                        </StyledTableCell>
                    )
                ))}
            </TableRow>
        </TableHead>
    );
}

function DevicesTable({ readOnly, fullAssign, style, isPaging, hiddenHeader, data, getListDevices, handleOnChangeCheckBox, total }) {
    const translate = useTranslate();
    const classes = useStyles();
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [orderBy, setOrderBy] = useState('ipAddress');
    const [order, setOrder] = React.useState('DESC');

    const handleChangePage = (event, newPage) => {
        const sort = { field: orderBy, order: order.toUpperCase() };
        const pagination = { page: newPage + 1, perPage: rowsPerPage };
        getListDevices(sort, pagination);
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(event.target.value);
        setPage(0);

        const sort = { field: orderBy, order: order.toUpperCase() };
        const pagination = { page: 1, perPage: event.target.value };
        getListDevices(sort, pagination);
    };

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'ASC';
        setOrder(isAsc ? 'ASC' : 'DESC');
        setOrderBy(property);
        setPage(0);

        const sort = { field: property, order: isAsc ? 'ASC' : 'DESC' };
        const pagination = { page: 1, perPage: rowsPerPage };
        getListDevices(sort, pagination);
    };

    const getTextClasses = (item) => {
        if (item.green) return classes.normalTextOnline;
        if (item.red) return classes.normalTextOffline;
        return classes.normalText;
    }
    if (!data) return null
    return (
        <Paper className={classes.root}>
            <TableContainer className={classes.container}>
                {
                    data.length > 0 ?
                        <Table size="small" aria-label="sticky table">
                            {
                                !hiddenHeader &&
                                <EnhancedTableHead style={style} classes={classes} order={order} orderBy={orderBy} onRequestSort={handleRequestSort} />
                            }

                            <TableBody>
                                {

                                    data.map((item, index) => (
                                        style !== 'secondary' ?
                                            (
                                                <TableRow key={'table-row-' + index} >
                                                    <TableCell className={classes.tableCell}>{item.name}</TableCell>
                                                    <TableCell className={classes.tableCell}>{item.ipAddress}</TableCell>
                                                    <TableCell className={classes.tableCell}>{item.tvModel.name}</TableCell>
                                                    <TableCell className={classes.tableCell}>{item.id}</TableCell>
                                                    <TableCell className={classes.tableCell}>{item.serialNumber}</TableCell>
                                                    <TableCell className={classes.tableCell}>{item.firmware}</TableCell>
                                                    {/* <TableCell className={getTextClasses(item)}>{item.status}</TableCell> */}
                                                    <TableCell className={classes.tableCell}>
                                                        <Checkbox
                                                            disabled={readOnly || (fullAssign && (item.room === null))}
                                                            checked={item.room !== undefined && item.room !== null}
                                                            onChange={handleOnChangeCheckBox(item.id)} color="primary">
                                                        </Checkbox>
                                                    </TableCell>
                                                </TableRow>
                                            )
                                            :
                                            (
                                                !item.room && (
                                                    <TableRow key={'table-row-secondary' + index} >
                                                        <TableCell className={classes.tableCell}>{item.name}</TableCell>
                                                        <TableCell className={classes.tableCell}>{item.tvModel}</TableCell>
                                                        <TableCell className={classes.tableCell}>{item.id}</TableCell>
                                                        <TableCell className={classes.tableCell}>{item.serialNumber}</TableCell>
                                                        <TableCell className={classes.tableCell}>{item.firmware}</TableCell>
                                                        <TableCell className={classes.tableCell}>
                                                            <Checkbox disabled={readOnly || (fullAssign && (item.room === null))}
                                                                checked={item.room !== undefined && item.room !== null}
                                                                onChange={handleOnChangeCheckBox(item.id)} color="primary">
                                                            </Checkbox>
                                                        </TableCell>
                                                    </TableRow>
                                                )

                                            )

                                    ))

                                }
                            </TableBody>
                        </Table>
                        : (style === 'secondary' ? (<Typography className={classes.textTable}>{translate('pos.common.noRecordsFound')}</Typography>) :
                            (
                                <Box> <Table size="small" aria-label="sticky table">
                                    {
                                        !hiddenHeader &&
                                        <EnhancedTableHead style={style} classes={classes} order={order} orderBy={orderBy} onRequestSort={handleRequestSort} />
                                    }
                                </Table>
                                    <Box width='100%' display='flex' justifyContent='center'>
                                        <Typography className={classes.textTable} style={{ textAlign: 'center', paddingBottom: 20, paddingTop: 20 }}>{translate('pos.dashboard.notFoundDevicesAssign')}</Typography>
                                    </Box>
                                </Box>
                            ))}
            </TableContainer>
            {isPaging && <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={total}
                rowsPerPage={rowsPerPage}
                page={page}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
            />}

        </Paper>
    );
}

export default DevicesTable;
